import React, { useState, useCallback, useRef, useEffect, useMemo, Component } from 'react';
import ReactDOM from 'react-dom';
import { NodeSelection } from 'prosemirror-state';
import 'prosemirror-model';
import 'plantuml-encoder';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import 'prosemirror-commands';
import 'prosemirror-inputrules';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
/**
 *格式化时间字符串
 * @param time
 * @returns HH:MM格式字符串
 */ var formatTime = function(time) {
    var minute = parseInt("".concat(time / 60), 10);
    var second = parseInt("".concat(time % 60), 10);
    return "".concat(minute < 10 ? "0".concat(minute) : minute, ":").concat(second < 10 ? "0".concat(second) : second);
};

var __generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var __generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var AudioProvider = /*#__PURE__*/ function() {
    function AudioProvider() {
        _classCallCheck(this, AudioProvider);
        this.download = function(url, name) {
            window.open(url, "_blank");
        };
        this.handleUrl = function(originUrl) {
            return originUrl;
        };
        this.beforeUpload = function(file) {
            return true;
        };
        this.upload = function(file, onProgress) {
            return new Promise(function(resolve, reject) {
                reject(new Error("上传方法未定义"));
            });
        };
        this.audioTranscode = function() {
            var _ref = _asyncToGenerator(function(data, file) {
                return __generator$1(this, function(_state) {
                    return [
                        2,
                        new Promise(function(resolve) {
                            resolve("ok");
                        })
                    ];
                });
            });
            return function(data, file) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AudioProvider.prototype;
    _proto.onSelectFiles = function onSelectFiles(files) {
        return true;
    };
    return AudioProvider;
}();

var __generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var __generator$3 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var __generator$4 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function useForceUpdate() {
    var _useState = _slicedToArray(useState(0), 2), setTick = _useState[1];
    var update = useCallback(function() {
        setTick(function(tick) {
            return tick + 1;
        });
    }, []);
    return update;
}

var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
styleInject(css_248z);

function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
var Resizer = function(param) {
    var $container = param.$container, view = param.view, getPos = param.getPos, initialWidth = param.initialWidth, initialHeight = param.initialHeight, _param_fixedRatio = param.fixedRatio, fixedRatio = _param_fixedRatio === void 0 ? true : _param_fixedRatio, _param_autoHeight = param.autoHeight, autoHeight = _param_autoHeight === void 0 ? false : _param_autoHeight, _param_hideInfo = param.hideInfo, hideInfo = _param_hideInfo === void 0 ? false : _param_hideInfo, _param_limit = param.limit, limit = _param_limit === void 0 ? {} : _param_limit, onResizeStart = param.onResizeStart, onResizeEnd = param.onResizeEnd;
    if (!$container || !getPos()) return null;
    var limitRef = useRef({});
    limitRef.current.minWidth = limit.minWidth || 20;
    limitRef.current.minHeight = limit.minHeight || 20;
    limitRef.current.maxHeight = limit.maxHeight || Infinity;
    var _useState = _slicedToArray$1(useState("rb"), 2), infoPosition = _useState[0], setInfoPosition = _useState[1];
    var wrapperRef = useRef();
    // 获取最大宽度
    var pos = getPos();
    var doc = view.state.doc;
    // 获取父级block节点
    var blockNode = findParentNodeClosestToPos(doc.resolve(pos), function(n) {
        return n.isBlock;
    });
    var $blockNode = view.nodeDOM((blockNode === null || blockNode === void 0 ? void 0 : blockNode.pos) || 0);
    if (!$blockNode) {
        return null;
    }
    limitRef.current.maxWidth = limit.maxWidth || $blockNode.clientWidth;
    var ratio = initialHeight / initialWidth;
    if (fixedRatio) {
        limitRef.current.minHeight = Math.max(limitRef.current.minHeight, limitRef.current.minWidth * ratio);
        limitRef.current.minWidth = Math.max(limitRef.current.minWidth, limitRef.current.minHeight / ratio);
        limitRef.current.maxHeight = limitRef.current.maxWidth * ratio;
    }
    limitRef.current.minWidth = Math.min(limitRef.current.minWidth, limitRef.current.maxWidth);
    limitRef.current.minHeight = Math.min(limitRef.current.minHeight, limitRef.current.maxHeight);
    var startX = useRef(0);
    var startY = useRef(0);
    var isReverseX = useRef(false);
    var isReverseY = useRef(false);
    var initialWidthRef = useRef(0);
    var initialHeightRef = useRef(0);
    initialWidthRef.current = initialWidth;
    initialHeightRef.current = initialHeight;
    var currentSize = useRef({
        width: initialWidth,
        height: initialHeight
    });
    var update = useForceUpdate();
    var limitSize = function() {
        var _currentSize_current = currentSize.current, width = _currentSize_current.width, height = _currentSize_current.height;
        if (width >= limitRef.current.maxWidth) {
            currentSize.current.width = limitRef.current.maxWidth;
        } else if (width <= limitRef.current.minWidth) {
            currentSize.current.width = limitRef.current.minWidth;
        }
        if (height >= limitRef.current.maxHeight) {
            currentSize.current.height = limitRef.current.maxHeight;
        } else if (height <= limitRef.current.minHeight) {
            currentSize.current.height = limitRef.current.minHeight;
        }
    };
    useEffect(function() {
        var onMouseDown = function(e) {
            var classList = e.target && e.target.classList;
            if (!classList) {
                return;
            }
            var posList = [
                "lt",
                "rt",
                "lb",
                "rb"
            ];
            var posName = posList.find(function(item) {
                return classList.contains(item);
            });
            if (posName) {
                e.stopPropagation();
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                handleMouseDown(e, posName);
            }
        };
        var wrapper = wrapperRef.current;
        wrapper.addEventListener("mousedown", onMouseDown, false);
        return function() {
            wrapper.removeEventListener("mousedown", onMouseDown, false);
        };
    });
    useEffect(function() {
        currentSize.current.width = initialWidth;
        currentSize.current.height = initialHeight;
        if (!autoHeight) {
            // 防止容器节点大小没有同步更新
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        update();
    }, [
        initialWidth
    ]);
    var handleMouseMove = useCallback(function(e) {
        e.preventDefault();
        e.stopPropagation();
        var diffX = isReverseX.current ? startX.current - e.clientX : e.clientX - startX.current;
        var diffY = isReverseY.current ? startY.current - e.clientY : e.clientY - startY.current;
        currentSize.current.width = initialWidthRef.current + diffX;
        currentSize.current.height = initialHeightRef.current + diffY;
        if (fixedRatio) {
            currentSize.current.height = currentSize.current.width * ratio;
        }
        limitSize();
        currentSize.current.width = Math.round(currentSize.current.width);
        currentSize.current.height = Math.round(currentSize.current.height);
        $container.style.width = "".concat(currentSize.current.width, "px");
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        // 更新尺寸大小的显示
        update();
    }, []);
    var handleMouseUp = useCallback(function() {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        onResizeEnd({
            width: currentSize.current.width,
            height: currentSize.current.height
        });
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        $container.style.width = "".concat(currentSize.current.width, "px");
    }, []);
    var handleMouseDown = function(e, position) {
        isReverseX.current = position === "lt" || position === "lb";
        isReverseY.current = position === "lt" || position === "lr";
        startX.current = e.clientX;
        startY.current = e.clientY;
        setInfoPosition(position);
        if (onResizeStart) {
            onResizeStart();
        }
        document.addEventListener("mousemove", handleMouseMove, {
            passive: false
        });
        document.addEventListener("mouseup", handleMouseUp);
    };
    // 当图片尺寸较大时，扩大热区
    var largeHotArea = useMemo(function() {
        return currentSize.current.height >= 30 && currentSize.current.width >= 30;
    }, [
        currentSize.current.height,
        currentSize.current.width
    ]);
    var resizerPrefix = classNamePrefix("pc-resizer");
    var pointerCls = "".concat(resizerPrefix, "-point");
    return /*#__PURE__*/ React.createElement("div", {
        className: resizerPrefix,
        ref: wrapperRef
    }, /*#__PURE__*/ React.createElement("span", {
        className: "".concat(pointerCls, " lt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ React.createElement("span", {
        className: "".concat(pointerCls, " rt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ React.createElement("span", {
        className: "".concat(pointerCls, " lb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ React.createElement("span", {
        className: "".concat(pointerCls, " rb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ React.createElement("span", {
        className: "".concat(resizerPrefix, "-info ").concat(infoPosition, " ").concat((currentSize.current.width < 65 || currentSize.current.height < 30) && "out", " ").concat(hideInfo ? "auto-hide" : "")
    }, "".concat(currentSize.current.width, " x ").concat(currentSize.current.height)));
};

var img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%92%ad%e6%94%be%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-471.000000%2c -558.000000)'%3e %3cg id='Group-18' transform='translate(471.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M15.6839276%2c10.5567733 L4.96564206%2c16.9107492 C4.66057577%2c17.0915976 4.26783668%2c16.9889051 4.08843476%2c16.6813793 C4.03053197%2c16.5821239 4%2c16.4690706 4%2c16.3539244 L4%2c3.64597255 C4%2c3.28921176 4.28689869%2c3 4.64080615%2c3 C4.7550314%2c3 4.86718053%2c3.03077813 4.96564206%2c3.08914775 L15.6839276%2c9.44312369 C15.9889939%2c9.62397201 16.090865%2c10.0198775 15.9114631%2c10.3274033 C15.8562054%2c10.4221245 15.7778912%2c10.5010701 15.6839276%2c10.5567733 Z' id='Triangle-2' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e6%9a%82%e5%81%9c%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-395.000000%2c -558.000000)'%3e %3cg id='Group-18-Copy' transform='translate(395.000000%2c 558.000000)'%3e %3crect id='Rectangle-27' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M5%2c3 L7%2c3 C7.55228475%2c3 8%2c3.44771525 8%2c4 L8%2c16 C8%2c16.5522847 7.55228475%2c17 7%2c17 L5%2c17 C4.44771525%2c17 4%2c16.5522847 4%2c16 L4%2c4 C4%2c3.44771525 4.44771525%2c3 5%2c3 Z M13%2c3 L15%2c3 C15.5522847%2c3 16%2c3.44771525 16%2c4 L16%2c16 C16%2c16.5522847 15.5522847%2c17 15%2c17 L13%2c17 C12.4477153%2c17 12%2c16.5522847 12%2c16 L12%2c4 C12%2c3.44771525 12.4477153%2c3 13%2c3 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9f%b3%e9%87%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-514.000000%2c -558.000000)'%3e %3cg id='Group-22' transform='translate(514.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(2.000000%2c 4.000000)'%3e %3cg id='Group-21'%3e %3cpath d='M0%2c8.12082937 C0%2c8.6754175 0.442660332%2c9.125 0.998956561%2c9.125 L3%2c9.125 L6.19054031%2c11.4182009 C6.63759255%2c11.7395196 7%2c11.544239 7%2c10.9975267 L7%2c1.00247329 C7%2c0.448822582 6.63085938%2c0.265319824 6.19054031%2c0.58179915 L3%2c2.875 L0.998956561%2c2.875 C0.447248087%2c2.875 0%2c3.32448459 0%2c3.87917063 L0%2c8.12082937 Z' id='Fill-89' fill='%236B6B6B'%3e%3c/path%3e %3cpath d='M10%2c2 C11.3333333%2c3.06070964 12%2c4.39404297 12%2c6 C12%2c7.60595703 11.3333333%2c8.93929036 10%2c10' id='Path-12' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3cpath d='M13%2c0 C15%2c1.3984375 16%2c3.3984375 16%2c6 C16%2c8.6015625 15%2c10.6015625 13%2c12' id='Path-12-Copy' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e9%9d%99%e9%9f%b3%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-550.000000%2c -558.000000)'%3e %3cg id='Group-22-Copy' transform='translate(550.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cg id='Group-20' transform='translate(4.000000%2c 4.000000)' fill='%236B6B6B'%3e %3cpath d='M9%2c1.72792206 L2.12273522%2c8.60518684 C2.04439515%2c8.46156167 2%2c8.29646112 2%2c8.12082937 L2%2c3.87917063 C2%2c3.32448459 2.44724809%2c2.875 2.99895656%2c2.875 L5%2c2.875 L8.19054031%2c0.58179915 C8.63085937%2c0.265319824 9%2c0.448822582 9%2c1.00247329 L9%2c1.72792206 Z M9%2c6.67766953 L9%2c10.9975267 C9%2c11.544239 8.63759255%2c11.7395196 8.19054031%2c11.4182009 L5.90337136%2c9.77429817 L9%2c6.67766953 Z M12.2582521%2c0.944543648 C12.5511454%2c1.23743687 12.5511454%2c1.7123106 12.2582521%2c2.00520382 L2.00520382%2c12.2582521 C1.7123106%2c12.5511454 1.23743687%2c12.5511454 0.944543648%2c12.2582521 C0.651650429%2c11.9653589 0.651650429%2c11.4904852 0.944543648%2c11.197592 L11.197592%2c0.944543648 C11.4904852%2c0.651650429 11.9653589%2c0.651650429 12.2582521%2c0.944543648 Z' id='Combined-Shape'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e5%85%a8%e5%b1%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-586.000000%2c -558.000000)'%3e %3cg id='Group-24' transform='translate(586.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M17.028246%2c3.75000027 C17.0282663%2c3.75227439 17.0282764%2c3.75455093 17.0282764%2c3.75682984 L17.0282764%2c9.25682984 C17.0282764%2c9.6710434 16.69249%2c10.0068298 16.2782764%2c10.0068298 C15.8640629%2c10.0068298 15.5282764%2c9.6710434 15.5282764%2c9.25682984 L15.5282764%2c5.55025253 L11.5803179%2c9.4982111 C11.2874247%2c9.79110432 10.8125509%2c9.79110432 10.5196577%2c9.4982111 C10.2267645%2c9.20531788 10.2267645%2c8.73044414 10.5196577%2c8.43755093 L14.4572086%2c4.5 L10.7782764%2c4.5 C10.3640629%2c4.5 10.0282764%2c4.16421356 10.0282764%2c3.75 C10.0282764%2c3.33578644 10.3640629%2c3 10.7782764%2c3 L16.2782764%2c3 C16.69249%2c3 17.0282764%2c3.33578644 17.0282764%2c3.75 Z M3.00003045%2c16.2499997 C3.00001016%2c16.2477256 3%2c16.2454491 3%2c16.2431702 L3%2c10.7431702 C3%2c10.3289566 3.33578644%2c9.99317016 3.75%2c9.99317016 C4.16421356%2c9.99317016 4.5%2c10.3289566 4.5%2c10.7431702 L4.5%2c14.4497475 L8.44795857%2c10.5017889 C8.74085178%2c10.2088957 9.21572552%2c10.2088957 9.50861874%2c10.5017889 C9.80151196%2c10.7946821 9.80151196%2c11.2695559 9.50861874%2c11.5624491 L5.57106781%2c15.5 L9.25%2c15.5 C9.66421356%2c15.5 10%2c15.8357864 10%2c16.25 C10%2c16.6642136 9.66421356%2c17 9.25%2c17 L3.75%2c17 C3.33578644%2c17 3%2c16.6642136 3%2c16.25 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e7%bc%a9%e5%b0%8f%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='V1.2_Icon%e6%b1%87%e6%80%bb' transform='translate(-622.000000%2c -558.000000)'%3e %3cg id='Group-24-Copy' transform='translate(622.000000%2c 558.000000)'%3e %3crect id='Rectangle-30' stroke='%23979797' fill='%23D8D8D8' opacity='0' x='0.5' y='0.5' width='19' height='19'%3e%3c/rect%3e %3cpath d='M7.44974747%2c11.5068298 L3.77827644%2c11.5068298 C3.36406288%2c11.5068298 3.02827644%2c11.1710434 3.02827644%2c10.7568298 C3.02827644%2c10.3426163 3.36406288%2c10.0068298 3.77827644%2c10.0068298 L9.27827644%2c10.0068298 C9.69249001%2c10.0068298 10.0282764%2c10.3426163 10.0282764%2c10.7568298 C10.0282663%2c10.7591042 10.0282764%2c10.7613808 10.0282764%2c10.7636597 L10.0282764%2c16.2636597 C10.0282764%2c16.6778732 9.69249001%2c17.0136597 9.27827644%2c17.0136597 C8.86406288%2c17.0136597 8.52827644%2c16.6778732 8.52827644%2c16.2636597 L8.52827644%2c12.5496212 L4.59099026%2c16.4869074 C4.29809704%2c16.7798006 3.8232233%2c16.7798006 3.53033009%2c16.4869074 C3.23743687%2c16.1940142 3.23743687%2c15.7191404 3.53033009%2c15.4262472 L7.44974747%2c11.5068298 Z M11.5%2c7.46403847 L15.4372862%2c3.52675228 C15.7301794%2c3.23385906 16.2050531%2c3.23385906 16.4979464%2c3.52675228 C16.7908396%2c3.8196455 16.7908396%2c4.29451923 16.4979464%2c4.58741245 L12.578529%2c8.50682984 L16.25%2c8.50682984 C16.6642136%2c8.50682984 17%2c8.84261627 17%2c9.25682984 C17%2c9.6710434 16.6642136%2c10.0068298 16.25%2c10.0068298 L10.75%2c10.0068298 C10.3357864%2c10.0068298 10%2c9.6710434 10%2c9.25682984 C10.0000102%2c9.25455545 10%2c9.25227891 10%2c9.25 L10%2c3.75 C10%2c3.33578644 10.3357864%2c3 10.75%2c3 C11.1642136%2c3 11.5%2c3.33578644 11.5%2c3.75 L11.5%2c7.46403847 Z' id='Combined-Shape' fill='%236B6B6B'%3e%3c/path%3e %3c/g%3e %3cg id='Group-5' transform='translate(395.000000%2c 558.000000)'%3e%3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3e%e4%b8%8b%e8%bd%bd copy%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e9%99%84%e4%bb%b6%e6%b7%bb%e5%8a%a0%e5%a4%8d%e5%88%b6%e9%93%be%e6%8e%a5' transform='translate(-369.000000%2c -555.000000)' fill='%23747272'%3e %3cg id='%e4%b8%8a%e4%bc%a0%e9%99%84%e4%bb%b6%e4%b8%ad-copy-6' transform='translate(56.000000%2c 534.000000)'%3e %3cg id='%e4%b8%8b%e8%bd%bd-copy' transform='translate(312.000000%2c 20.000000)'%3e %3cpath d='M8.81079102%2c8.49228232 L11.0575929%2c6.23659883 C11.367661%2c5.92438892 11.8514298%2c5.89865471 12.1342183%2c6.18304917 C12.4189783%2c6.46942638 12.3934758%2c6.95251315 12.0816605%2c7.26648227 L8.65828197%2c10.7033935 C8.57058276%2c10.8187868 8.45021995%2c10.9080019 8.31097304%2c10.9572592 C8.23162324%2c10.986943 8.14990291%2c11.0008681 8.06879562%2c10.9999582 C8.06613072%2c10.999986 8.0634625%2c11 8.06079102%2c11 C8.05811953%2c11 8.05545131%2c10.999986 8.05278641%2c10.9999582 C7.97167912%2c11.0008681 7.88995879%2c10.986943 7.81060899%2c10.9572592 C7.67136208%2c10.9080019 7.55099928%2c10.8187868 7.46330006%2c10.7033935 L4.03992152%2c7.26648227 C3.72810619%2c6.95251315 3.70260373%2c6.46942638 3.98736375%2c6.18304917 C4.27015222%2c5.89865471 4.75392098%2c5.92438892 5.06398917%2c6.23659883 L7.31079102%2c8.49228232 L7.31079102%2c1.75 C7.31079102%2c1.33578644 7.64657745%2c1 8.06079102%2c1 C8.47500458%2c1 8.81079102%2c1.33578644 8.81079102%2c1.75 L8.81079102%2c8.49228232 Z M15%2c11.0225156 L15%2c13 C15%2c14.1045695 14.1045695%2c15 13%2c15 L3%2c15 C1.8954305%2c15 1%2c14.1045695 1%2c13 L1%2c11 L1.00152941%2c11 C1.00051495%2c10.9840173 1%2c10.9678989 1%2c10.9516602 C1%2c10.5365365 1.33652425%2c10.2000122 1.75164795%2c10.2000122 C2.16677165%2c10.2000122 2.5032959%2c10.5365365 2.5032959%2c10.9516602 C2.5032959%2c10.9755555 2.50218087%2c10.9991903 2.5%2c11.0225156 L2.5%2c12.5 C2.5%2c13.0522847 2.94771525%2c13.5 3.5%2c13.5 L12.5%2c13.5 C13.0522847%2c13.5 13.5%2c13.0522847 13.5%2c12.5 L13.5%2c11 L13.5015294%2c11 C13.5005149%2c10.9840173 13.5%2c10.9678989 13.5%2c10.9516602 C13.5%2c10.5365365 13.8365242%2c10.2000122 14.2516479%2c10.2000122 C14.6667716%2c10.2000122 15.0032959%2c10.5365365 15.0032959%2c10.9516602 C15.0032959%2c10.9755555 15.0021809%2c10.9991903 15%2c11.0225156 Z' id='%e4%b8%8b%e8%bd%bd'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var VIDEO_DEFAULT_WIDTH = 512;
var VIDEO_DEFAULT_HEIGHT = 288;
var PROGRESS_DEFAULT_WIDTH = 235;
// const { isMobile } = getSystemInfo(); // isMobile主要用于toView场景的处理
var getPositiveNumber = function(num) {
    return num < 0 ? 0 : num;
};
var Video = /*#__PURE__*/ function(Component) {
    _inherits(Video, Component);
    var _super = _createSuper(Video);
    function Video(props) {
        _classCallCheck$1(this, Video);
        var _this;
        _this = _super.call(this, props);
        _this.isOnProgressMouseDown = false // 鼠标是否在视频进度条按下状态
        ;
        _this.isOnVolumeMouseDown = false // 鼠标是否在volumeBar（音量条）按下状态
        ;
        _this.state = {
            init: true,
            volume: 0.5,
            isMute: false,
            progress: 0,
            playing: 0,
            current: "00:00",
            total: "00:00",
            isPlay: false,
            hasTip: false,
            tipInfo: {
                // 鼠标在进度条上的时间提示
                time: "00:00",
                offsetX: 0
            },
            showToolBar: true,
            showVolumeBar: false,
            isFullScreen: false,
            isError: false,
            progressWidth: PROGRESS_DEFAULT_WIDTH,
            downloadStatus: 0,
            isResizing: false
        };
        _this.observer = null // 增加observer订阅侧边栏变化的事件，更新进度条实际宽度。目前没有想到更好的办法解决这个问题
        ;
        /**
   * 全屏
   */ _this.handleFullScreenChange = function() {
            var isFullScreen = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen || document.msIsFullScreen;
            if (!isFullScreen) _this.setState({
                isFullScreen: false
            });
        };
        /**
   * 切换播放暂停
   */ _this.togglePlay = function() {
            var isPlay = _this.state.isPlay;
            _this.setState({
                isPlay: !isPlay
            });
            if (isPlay) {
                var _this_video;
                (_this_video = _this.video) === null || _this_video === void 0 ? void 0 : _this_video.pause();
            } else {
                document.querySelectorAll("audio").forEach(function(otherAudio) {
                    return otherAudio.pause();
                });
                document.querySelectorAll("video").forEach(function(otherVideo) {
                    return otherVideo !== _this.video && otherVideo.pause();
                });
                // this.video && this.video.play()
                if (_this.video) {
                    var playPromise = _this.video.play();
                    if (playPromise !== undefined) {
                        playPromise.then(function() {}).catch(function(e) {
                            console.error(e);
                        });
                    }
                }
            }
        };
        /**
   * 浏览器可以开始播放时触发
   */ _this.handleCanPlay = function() {
            var duration = getPositiveNumber(_this.video.duration);
            var total = formatTime(duration);
            _this.setState({
                total: total
            });
        };
        /**
   * 视频正在下载触发
   */ _this.handleProgress = function() {
            if (_this.video.buffered.length <= 0) {
                return;
            }
            var progress = getPositiveNumber(_this.video.buffered.end(0) / _this.video.duration);
            _this.setState({
                progress: progress
            });
        };
        /**
   * 视频暂停时触发
   */ _this.handlePause = function() {
            if (document.hidden) return;
            var _this_state = _this.state, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar;
            if (isPlay) {
                _this.setState({
                    isPlay: false
                });
            }
            if (!showToolBar) _this.setState({
                showToolBar: true
            });
        };
        /**
   * 播放位置改变重新定位
   */ _this.handleTimeUpdate = function() {
            var currentTime = getPositiveNumber(_this.video.currentTime);
            var current = formatTime(currentTime);
            var playing = currentTime / _this.video.duration;
            _this.setState({
                current: current,
                playing: playing
            });
            var init = _this.state.init;
            if (init) _this.setState({
                init: false
            });
        };
        _this.handleVideoMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 视频区域鼠标移动响应，进度条拖动则更新进度
   */ _this.handleVideoMouseMove = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth, showToolBar = _this_state.showToolBar;
            var left = _this.progressBar.getBoundingClientRect().left;
            var zoom = _this.props.zoom;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var calculateProgressWidth = isFullScreen ? PROGRESS_DEFAULT_WIDTH : progressWidth;
            var newCurrentTime = getPositiveNumber(dis / calculateProgressWidth * _this.video.duration);
            if (_this.isOnProgressMouseDown) {
                _this.video.currentTime = newCurrentTime;
                _this.handleTimeUpdate();
            }
            if (!showToolBar) _this.setState({
                showToolBar: true
            });
            _this.toggleToolbarDebounce();
        };
        _this.handleVideoMouseLeave = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 鼠标按下进度条某处
   */ _this.handleProgressBarMouseDown = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth;
            var calculateProgressWidth = isFullScreen ? PROGRESS_DEFAULT_WIDTH : progressWidth;
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = getPositiveNumber(dis / calculateProgressWidth * _this.video.duration);
            _this.video.currentTime = newCurrentTime;
            _this.isOnProgressMouseDown = true;
            e.preventDefault();
        };
        /**
   * 进度条上的鼠标释放
   */ _this.handleProgressBarMouseUp = function() {
            _this.isOnProgressMouseDown = false;
        };
        /**
   * 进度条区域鼠标移动响应，设置鼠标位置时间提示
   */ _this.handleProgressMouseMove = function(e) {
            var _this_state = _this.state, isFullScreen = _this_state.isFullScreen, progressWidth = _this_state.progressWidth;
            var calculateProgressWidth = isFullScreen ? PROGRESS_DEFAULT_WIDTH : progressWidth;
            var zoom = _this.props.zoom;
            var left = _this.progressBar.getBoundingClientRect().left;
            var clientX = e.nativeEvent.clientX / zoom;
            var dis = clientX - left;
            var newCurrentTime = dis / calculateProgressWidth * _this.video.duration;
            if (newCurrentTime > _this.video.duration || newCurrentTime < 0) {
                _this.setState({
                    hasTip: false
                });
                return;
            }
            _this.setState({
                hasTip: true,
                tipInfo: {
                    time: formatTime(newCurrentTime),
                    offsetX: dis
                }
            });
        };
        /**
   * 在音量条按下鼠标后移动调整音量
   */ _this.handleVolumeBarMouseDown = function(e) {
            var bottom = _this.volumeBar.getBoundingClientRect().bottom;
            var zoom = _this.props.zoom;
            var clientY = e.nativeEvent.clientY / zoom;
            var dis = bottom - clientY;
            var volume = (dis > 0 ? dis : 0) / 80;
            volume = volume > 1 ? 1 : volume;
            _this.video.volume = volume;
            _this.setState({
                volume: volume,
                isMute: false
            });
            _this.isOnVolumeMouseDown = true;
            e.preventDefault();
        };
        /**
   * 音量条上的鼠标释放
   */ _this.handleVolumeBarMouseUp = function() {
            _this.isOnVolumeMouseDown = false;
        };
        /**
   * 在音量条按下鼠标后移动调整音量
   */ _this.handleVolumeBarMouseMove = function(e) {
            if (_this.isOnVolumeMouseDown) {
                _this.handleVolumeBarMouseDown(e);
            }
        };
        _this.showVolumeBar = function() {
            _this.setState({
                showVolumeBar: true
            });
        };
        _this.hideVolumeBar = function() {
            _this.setState({
                showVolumeBar: false
            });
        };
        /**
   * 静音切换
   */ _this.toggleMute = function() {
            var _this_state = _this.state, volume = _this_state.volume, isMute = _this_state.isMute;
            if (isMute) {
                _this.video.volume = volume;
                _this.setState({
                    isMute: false
                });
            } else {
                _this.video.volume = 0;
                _this.setState({
                    isMute: true
                });
            }
        };
        /**
   * 双击全屏切换
   */ _this.toggleScale = function() {
            var isFullScreen = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen || document.msIsFullScreen;
            if (isFullScreen) {
                var efs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
                if (efs) {
                    efs.call(document);
                }
            } else {
                var rfs = _this.video.requestFullscreen || _this.video.webkitRequestFullscreen || _this.video.mozRequestFullScreen || _this.video.msRequestFullscreen;
                if (rfs) {
                    rfs.call(_this.video.parentElement.parentElement);
                }
                _this.setState({
                    isFullScreen: true
                });
            }
        };
        /**
   * 切换toolbar(视频下方工具栏包括进度条音量等)展示隐藏
   */ _this.toggleToolbar = function() {
            var _this_state = _this.state, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar;
            if (isPlay && showToolBar) {
                _this.setState({
                    showToolBar: false
                });
            }
        };
        /**
   * 处理视频文件下载
   */ _this.handleDownload = function() {
            var _provider_handleUrl;
            var downloadStatus = _this.state.downloadStatus;
            if (downloadStatus === 1) return;
            var _this_props = _this.props, url = _this_props.url, name = _this_props.name, provider = _this_props.provider;
            var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
            provider.download(src, name);
        };
        _this.handleDragStart = function(e) {
            e.preventDefault();
        };
        /**
   * 视频文件异常错误处理，可以做一些异常上报的工作
   */ _this.handleError = function() {
            _this.setState({
                isError: true
            });
            var _this_props = _this.props, handleVideoError = _this_props.provider.handleVideoError, url = _this_props.url;
            // 提供给业务方进行视频错误处理
            handleVideoError === null || handleVideoError === void 0 ? void 0 : handleVideoError(_this.video.error, url);
        };
        /**
   * 文件获取失败重试
   */ _this.handleRetry = function() {
            _this.setState({
                isError: false
            });
        };
        _this.handleResizeStart = function() {
            _this.setState({
                isResizing: true
            });
        };
        /**
   * 调整完成后调用
   * @param size object 包括调整后的width、height
   */ _this.handleResizeEnd = function(size) {
            var _this_video;
            var _this_props = _this.props, view = _this_props.view, getPos = _this_props.getPos;
            var state = view.state, dispatch = view.dispatch;
            var tr = state.tr, doc = state.doc;
            var pos = getPos();
            var node = doc.nodeAt(pos);
            dispatch(tr.setNodeMarkup(pos, null, _objectSpreadProps(_objectSpread({}, node.attrs), {
                width: size.width,
                height: size.height
            })).setSelection(NodeSelection.create(tr.doc, pos)) // 重新设置选区
            );
            // 调整视频宏大小后需要重置进度
            _this.setState({
                current: "00:00",
                isPlay: false,
                playing: 0,
                progress: 0,
                progressWidth: _this.progressBar.clientWidth,
                isResizing: false
            });
            _this.video.currentTime = 0;
            (_this_video = _this.video) === null || _this_video === void 0 ? void 0 : _this_video.pause();
        };
        _this.toggleToolbarDebounce = debounce(_this.toggleToolbar, 3e3);
        return _this;
    }
    var _proto = Video.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        if (document.exitFullscreen) {
            document.addEventListener("fullscreenchange", this.handleFullScreenChange);
        } else if (document.webkitExitFullscreen) {
            document.addEventListener("webkitfullscreenchange", this.handleFullScreenChange);
        } else if (document.mozCancelFullScreen) {
            document.addEventListener("mozfullscreenchange", this.handleFullScreenChange);
        } else if (document.exitFullscreen) {
            document.addEventListener("MSFullscreenChange", this.handleFullScreenChange);
        }
        // if (!isMobile) {
        this.timer = setTimeout(function() {
            var _this_progressBar;
            if (((_this_progressBar = _this.progressBar) === null || _this_progressBar === void 0 ? void 0 : _this_progressBar.clientWidth) !== PROGRESS_DEFAULT_WIDTH) {
                _this.setState({
                    progressWidth: _this.progressBar.clientWidth
                });
            }
            // observer相关代码
            var target = document.querySelector(".resize-box");
            if (target) {
                var config = {
                    attributes: true
                };
                var resetWidth = function() {
                    if (_this.progressBar) {
                        _this.setState({
                            progressWidth: _this.progressBar.clientWidth
                        });
                    }
                };
                _this.observer = new MutationObserver(resetWidth);
                _this.observer.observe(target, config);
            }
        }, 0);
    // }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (document.exitFullscreen) {
            document.removeEventListener("fullscreenchange", this.handleFullScreenChange);
        } else if (document.webkitExitFullscreen) {
            document.removeEventListener("webkitfullscreenchange", this.handleFullScreenChange);
        } else if (document.mozCancelFullScreen) {
            document.removeEventListener("mozfullscreenchange", this.handleFullScreenChange);
        } else if (document.msExitFullscreen) {
            document.removeEventListener("MSFullscreenChange", this.handleFullScreenChange);
        }
        this.timer && clearTimeout(this.timer);
        // !isMobile && this.observer && this.observer.disconnect();
        this.observer && this.observer.disconnect();
    };
    _proto.render = function render() {
        var _this = this;
        var _provider_handleUrl;
        var _this_props = this.props, url = _this_props.url, width = _this_props.width, height = _this_props.height, view = _this_props.view, getPos = _this_props.getPos, provider = _this_props.provider, resizer = _this_props.resizer;
        var _this_state = this.state, init = _this_state.init, volume = _this_state.volume, isMute = _this_state.isMute, progress = _this_state.progress, playing = _this_state.playing, current = _this_state.current, total = _this_state.total, isPlay = _this_state.isPlay, showToolBar = _this_state.showToolBar, showVolumeBar = _this_state.showVolumeBar, isFullScreen = _this_state.isFullScreen, isError = _this_state.isError, hasTip = _this_state.hasTip, _this_state_tipInfo = _this_state.tipInfo, time = _this_state_tipInfo.time, offsetX = _this_state_tipInfo.offsetX, downloadStatus = _this_state.downloadStatus, progressWidth = _this_state.progressWidth, isResizing = _this_state.isResizing;
        var calculateProgressWidth = isFullScreen ? PROGRESS_DEFAULT_WIDTH : progressWidth;
        // 业务方可以对url进行加工处理
        var src = (provider === null || provider === void 0 ? void 0 : (_provider_handleUrl = provider.handleUrl) === null || _provider_handleUrl === void 0 ? void 0 : _provider_handleUrl.call(provider, url)) || url;
        var VIDEO_WIDTH = +width < VIDEO_DEFAULT_WIDTH ? VIDEO_DEFAULT_WIDTH : +width;
        var VIDEO_HEIGHT = +height < VIDEO_DEFAULT_HEIGHT ? VIDEO_DEFAULT_HEIGHT : +height;
        var style = {
            width: "".concat(VIDEO_WIDTH, "px"),
            height: "".concat(VIDEO_HEIGHT, "px")
        };
        // const isPrint = window.location.href.includes("print"); // 是否为打印页面
        // if (isError && !isPrint) {
        if (isError) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "".concat(classNamePrefix("video-view"), " error"),
                style: style
            }, /*#__PURE__*/ React.createElement("div", {
                className: "notice",
                "data-src": src
            }, window.navigator.onLine ? "文件获取失败" : "网络连接失败"), /*#__PURE__*/ React.createElement("button", {
                className: "retry ".concat(classNamePrefix("btn")),
                onClick: this.handleRetry
            }, "重试"));
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: classNamePrefix("video-view"),
            style: style,
            onMouseUp: this.handleVideoMouseUp,
            onMouseMove: this.handleVideoMouseMove,
            onMouseLeave: this.handleVideoMouseLeave,
            onDragStart: this.handleDragStart,
            ref: function(ref) {
                _this.videoWrapper = ref;
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: classNames("middle", {
                pause: !isPlay
            }),
            onClick: this.togglePlay
        }, /*#__PURE__*/ React.createElement("video", {
            ref: function(ref) {
                _this.video = ref;
            },
            src: src,
            preload: "meta",
            volume: isMute ? 0 : volume,
            onCanPlay: this.handleCanPlay,
            onProgress: this.handleProgress,
            onTimeUpdate: this.handleTimeUpdate,
            onPause: this.handlePause,
            onDoubleClick: this.toggleScale,
            onError: this.handleError
        }, "本浏览器不支持 HTML5 video 标签")), /*#__PURE__*/ React.createElement("div", {
            className: classNames("bottom", {
                hidden: !showToolBar
            })
        }, /*#__PURE__*/ React.createElement("div", {
            className: "play-btn",
            onClick: this.togglePlay
        }, !isPlay ? /*#__PURE__*/ React.createElement("img", {
            src: img,
            alt: "播放"
        }) : /*#__PURE__*/ React.createElement("img", {
            src: img$1,
            alt: "暂停"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "progress-bar",
            ref: function(ref) {
                _this.progressBar = ref;
            },
            onMouseDown: this.handleProgressBarMouseDown,
            onMouseMove: this.handleProgressMouseMove,
            onMouseLeave: function() {
                return _this.setState({
                    hasTip: false
                });
            },
            style: isResizing ? {
                overflow: "hidden"
            } : {}
        }, /*#__PURE__*/ React.createElement("div", {
            className: "load-bar",
            style: {
                width: "".concat(init ? 0 : progress * calculateProgressWidth, "px")
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: classNames("played-bar", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                width: "".concat(playing * calculateProgressWidth, "px")
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: classNames("played-button", {
                dragged: this.isOnProgressMouseDown
            }),
            style: {
                left: "".concat(playing * calculateProgressWidth, "px")
            }
        }), hasTip && /*#__PURE__*/ React.createElement("div", {
            className: "progress-tip-wrapper",
            style: {
                left: "".concat(offsetX - 22, "px")
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: "progress-tip"
        }, time))), /*#__PURE__*/ React.createElement("div", {
            className: "time"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "current"
        }, current), /*#__PURE__*/ React.createElement("span", null, "/"), /*#__PURE__*/ React.createElement("span", {
            className: "total"
        }, total)), /*#__PURE__*/ React.createElement("div", {
            className: "volume-btn",
            onMouseEnter: this.showVolumeBar,
            onMouseLeave: this.hideVolumeBar,
            onDragStart: this.handleDragStart
        }, isMute || volume < 0.01 ? /*#__PURE__*/ React.createElement("img", {
            src: img$3,
            alt: "静音",
            onClick: this.toggleMute
        }) : /*#__PURE__*/ React.createElement("img", {
            src: img$2,
            alt: "音量",
            onClick: this.toggleMute
        }), showVolumeBar && /*#__PURE__*/ React.createElement("div", {
            className: "volume-bar-wrapper",
            onMouseMove: this.handleVolumeBarMouseMove,
            onMouseUp: this.handleVolumeBarMouseUp
        }, /*#__PURE__*/ React.createElement("div", {
            className: "volume-bar",
            ref: function(ref) {
                _this.volumeBar = ref;
            },
            onMouseDown: this.handleVolumeBarMouseDown
        }, /*#__PURE__*/ React.createElement("div", {
            className: "selected-bar",
            style: {
                height: "".concat(isMute ? 0 : volume * 80, "px")
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: "bar-btn"
        }))))), /*#__PURE__*/ React.createElement("div", {
            className: "scale-btn",
            onClick: this.toggleScale
        }, isFullScreen ? /*#__PURE__*/ React.createElement("img", {
            src: img$5,
            alt: "缩小"
        }) : /*#__PURE__*/ React.createElement("img", {
            src: img$4,
            alt: "缩小"
        })), /*#__PURE__*/ React.createElement("div", {
            className: classNames("download-btn", {
                error: downloadStatus === 2,
                "video-loading": downloadStatus === 1
            }),
            onClick: this.handleDownload
        }, /*#__PURE__*/ React.createElement("div", {
            className: "tip-wrapper"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "tip"
        }, "下载失败，请重试")), /*#__PURE__*/ React.createElement("img", {
            src: img$6,
            alt: "下载"
        }))), this.videoWrapper && resizer && /*#__PURE__*/ React.createElement(Resizer, {
            $container: this.videoWrapper,
            view: view,
            getPos: getPos,
            initialWidth: VIDEO_WIDTH,
            initialHeight: VIDEO_HEIGHT,
            onResizeEnd: this.handleResizeEnd,
            onResizeStart: this.handleResizeStart,
            limit: {
                minWidth: VIDEO_DEFAULT_WIDTH,
                minHeight: VIDEO_DEFAULT_HEIGHT
            },
            fixedRatio: false,
            hideInfo: true
        }));
    };
    return Video;
}(Component);
Video.defaultProps = {
    zoom: 1,
    resizer: true
};

var css_248z$1 = '.ct-video{margin:8px 0;max-width:100%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.ct-video.align-center{margin:0 auto}.ct-video.align-right{float:right;margin-top:0}.ct-video.align-right+*,.ct-video.align-right+div+span+*{clear:both}.ct-video-view{background:#f6f6f6;border:1px solid #ddd;height:288px;max-width:100%;min-height:288px;min-width:512px;position:relative;width:512px}.ct-video-view img{vertical-align:unset}.ct-video-view:hover{border:1px solid #3d91f2;cursor:pointer}.ct-video-view .middle{background:#000;height:100%;width:100%}.ct-video-view .middle:after{content:"";opacity:0;position:absolute;transition:opacity .3s ease}.ct-video-view .middle video{display:block;height:100%;width:100%}.ct-video-view .middle.pause{position:relative}.ct-video-view .middle.pause:after{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2218px%22 height%3D%2220px%22 viewBox%3D%220 0 18 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%A2%84%E8%A7%88%E6%92%AD%E6%94%BE%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard-2%22 transform%3D%22translate(-446.000000%2C -115.000000)%22 fill%3D%22%236B6B6B%22%3E            %3Cg id%3D%22Group-12%22 transform%3D%22translate(446.000000%2C 115.000000)%22%3E                %3Cpath d%3D%22M17.5258914%2C10.7953904 L1.4484631%2C19.8724989 C0.990863649%2C20.1308537 0.401755017%2C19.9841502 0.132652138%2C19.5448276 C0.0457979589%2C19.4030342 0%2C19.2415294 0%2C19.0770349 L3.41490118e-15%2C0.922817934 C3.41490118e-15%2C0.413159662 0.430348031%2C0 0.961209231%2C0 C1.1325471%2C0 1.30077079%2C0.0439687597 1.4484631%2C0.127353928 L17.5258914%2C9.20446242 C17.9834908%2C9.46281716 18.1362975%2C10.0283964 17.8671946%2C10.4677191 C17.7843081%2C10.603035 17.6668367%2C10.7158145 17.5258914%2C10.7953904 Z%22 id%3D%22Triangle-2%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 23px;background-color:#fff;border-radius:50%;height:60px;left:50%;margin-left:-30px;margin-top:-30px;opacity:1;top:50%;transition:opacity .3s ease;width:60px}.ct-video-view .middle.pause:before{background:rgba(0,0,0,.5);bottom:0;content:"";left:0;position:absolute;right:0;top:0}.ct-video-view .middle.pause:hover:after{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2218px%22 height%3D%2220px%22 viewBox%3D%220 0 18 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E9%A2%84%E8%A7%88%E6%92%AD%E6%94%BE%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard-2%22 transform%3D%22translate(-446.000000%2C -115.000000)%22 fill%3D%22%2323bdd9%22%3E            %3Cg id%3D%22Group-12%22 transform%3D%22translate(446.000000%2C 115.000000)%22%3E                %3Cpath d%3D%22M17.5258914%2C10.7953904 L1.4484631%2C19.8724989 C0.990863649%2C20.1308537 0.401755017%2C19.9841502 0.132652138%2C19.5448276 C0.0457979589%2C19.4030342 0%2C19.2415294 0%2C19.0770349 L3.41490118e-15%2C0.922817934 C3.41490118e-15%2C0.413159662 0.430348031%2C0 0.961209231%2C0 C1.1325471%2C0 1.30077079%2C0.0439687597 1.4484631%2C0.127353928 L17.5258914%2C9.20446242 C17.9834908%2C9.46281716 18.1362975%2C10.0283964 17.8671946%2C10.4677191 C17.7843081%2C10.603035 17.6668367%2C10.7158145 17.5258914%2C10.7953904 Z%22 id%3D%22Triangle-2%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 23px;background-color:#fff}.ct-video-view .bottom{background:#f6f6f6;bottom:0;display:flex;height:40px;padding:0 16px;position:absolute;transition:opacity .5s ease;width:100%}.ct-video-view .bottom:hover{opacity:1}.ct-video-view .bottom.hidden{opacity:0}.ct-video-view .play-btn{cursor:pointer;height:18px;margin-top:11px;transition:all .1s ease;width:18px}.ct-video-view .play-btn:hover path{fill:#3d91f2}.ct-video-view .progress-bar{background:#d9d9d9;background-clip:content-box;border-radius:100px;cursor:pointer;flex:1;height:10px;margin:16px 16px 0;padding:3px 0;position:relative}.ct-video-view .load-bar{background:#b6b6b6;transition:all 3s linear;z-index:1}.ct-video-view .load-bar,.ct-video-view .played-bar{border-radius:100px;height:4px;position:absolute;top:3px;width:0}.ct-video-view .played-bar{background:#1c6cdc;transition:all .3s linear;z-index:2}.ct-video-view .played-bar.dragged{transition:none}.ct-video-view .played-button{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);height:12px;position:absolute;top:-2px;transition:all .3s linear;width:12px;z-index:10}.ct-video-view .played-button.dragged{transition:none}.ct-video-view .progress-tip-wrapper{height:28px;left:0;position:absolute;top:-27px;width:48px}.ct-video-view .progress-tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-video-view .progress-tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;width:0}.ct-video-view .progress-tip:after,.ct-video-view .progress-tip:before{content:"";display:block;position:absolute;right:50%;transform:translate(50%);z-index:2}.ct-video-view .progress-tip:before{background:rgba(0,0,0,.68);bottom:-9px;height:4px;width:1px}.ct-video-view .time{display:flex;justify-content:space-between;align-items:center;color:#333;font-size:12px;line-height:12px;text-align:right;width:80px}.ct-video-view .volume-btn{cursor:pointer;height:40px;margin:0 16px;padding-top:10px;position:relative;transition:all .1s ease;width:20px}.ct-video-view .volume-btn:hover path:first-child{fill:#3d91f2}.ct-video-view .volume-btn:hover path:nth-child(2){stroke:#3d91f2}.ct-video-view .volume-bar-wrapper{background:#fff;border-radius:2px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);height:102px;left:-15%;position:absolute;top:-102px;width:30px;z-index:9}.ct-video-view .volume-bar{background:#d9d9d9;border-radius:100px;height:80px;left:50%;position:absolute;top:11px;transform:translate(-50%);width:4px}.ct-video-view .selected-bar{background:#1c6cdc;border-radius:100px;bottom:0;height:0;position:absolute;transition:all .2s;width:4px;z-index:2}.ct-video-view .selected-bar .bar-btn{background:#fff;border-radius:50%;box-shadow:0 1px 2px 0 rgba(0,0,0,.2);content:"";height:12px;position:absolute;right:-4px;top:-6px;width:12px}.ct-video-view .scale-btn{cursor:pointer;height:20px;margin-right:16px;margin-top:10px;transition:all .1s ease;width:20px}.ct-video-view .scale-btn:hover path{fill:#3d91f2}.ct-video-view .download-btn{cursor:pointer;height:24px;margin-top:10px;position:relative;transition:all .1s ease;width:25px}.ct-video-view .download-btn:hover path{fill:#3d91f2}.ct-video-view .download-btn .tip-wrapper{display:none;height:28px;left:7px;position:absolute;top:-30px}.ct-video-view .download-btn .tip{background:rgba(0,0,0,.68);border-radius:2px;color:#fff;font-size:12px;height:25px;left:50%;line-height:25px;padding:0 10px;position:absolute;top:0;transform:translate(-50%);vertical-align:middle;white-space:nowrap;z-index:9}.ct-video-view .download-btn .tip:after{border-color:rgba(0,0,0,.68) transparent;border-style:solid;border-width:4px 4px 0;bottom:-4px;content:"";display:block;position:absolute;right:50%;transform:translate(50%);width:0;z-index:2}.ct-video-view .download-btn.video-loading:after{-webkit-animation:loading .8s linear infinite;animation:loading .8s linear infinite;border-radius:50%;border:2px solid #d5d5d5;content:"";display:inline-block;height:18px;vertical-align:-8%;width:18px}.ct-video-view .download-btn.video-loading svg{display:none}.ct-video-view .download-btn.error{background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%228px%22 height%3D%228px%22 viewBox%3D%220 0 8 8%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 50.2 (55047) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3ECombined Shape%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Crect id%3D%22Rectangle-2%22 fill%3D%22%23FFFFFF%22 x%3D%222%22 y%3D%221%22 width%3D%224%22 height%3D%226%22%3E%3C%2Frect%3E        %3Cpath d%3D%22M0%2C4 C0%2C1.79088 1.79088%2C0 4%2C0 C6.20912%2C0 8%2C1.79088 8%2C4 C8%2C6.20912 6.20912%2C8 4%2C8 C1.79088%2C8 0%2C6.20912 0%2C4 Z M4.00000002%2C1.34999998 C3.34188252%2C1.34999998 2.87727375%2C1.67743076 3%2C2.5 L3.40000002%2C4.36638153 C3.40000002%2C4.69277782 3.66862917%2C4.96459961 4.00000002%2C4.96459961 C4.33368113%2C4.96459961 4.60000002%2C4.69676825 4.60000002%2C4.36638153 L5%2C2.5 C5.15197984%2C1.72235314 4.74297343%2C1.34999998 4.00000002%2C1.34999998 Z M4%2C6.65000002 C4.33137086%2C6.65000002 4.60000002%2C6.38137086 4.60000002%2C6.05 C4.60000002%2C5.71862914 4.33137086%2C5.44999998 4%2C5.44999998 C3.66862914%2C5.44999998 3.39999998%2C5.71862914 3.39999998%2C6.05 C3.39999998%2C6.38137086 3.66862914%2C6.65000002 4%2C6.65000002 Z%22 id%3D%22Combined-Shape%22 fill%3D%22%23F5222D%22%3E%3C%2Fpath%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 100% 0}.ct-video-view .download-btn.error:hover .tip-wrapper{display:block}.ct-video-view:-moz-full-screen{height:100%;width:100%}.ct-video-view:-moz-full-screen hover{border:none}.ct-video-view:-moz-full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:-moz-full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:full-screen{height:100%;width:100%}.ct-video-view:full-screen hover{border:none}.ct-video-view:full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:-webkit-full-screen{height:100%;width:100%}.ct-video-view:-ms-fullscreen{height:100%;width:100%}.ct-video-view:fullscreen{height:100%;width:100%}.ct-video-view:-webkit-full-screen hover{border:none}.ct-video-view:-ms-fullscreen hover{border:none}.ct-video-view:fullscreen hover{border:none}.ct-video-view:-webkit-full-screen .middle.pause:after{transform:scale(2)}.ct-video-view:-ms-fullscreen .middle.pause:after{transform:scale(2)}.ct-video-view:fullscreen .middle.pause:after{transform:scale(2)}.ct-video-view:-webkit-full-screen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:-ms-fullscreen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ct-video-view:fullscreen .bottom{bottom:40px;left:50%;margin-left:-256px;width:512px}.ProseMirror-selectednode .ct-video-view{border:1px solid #1c6cdc}.ct-video-view.error{background:rgba(0,0,0,.5);font-size:14px}.ct-video-view.error .notice{color:#fff;margin-top:100px;text-align:center}.ct-video-view.error .retry{background:#1c6cdc;border:none;color:#fff;display:block;height:32px;line-height:32px;margin:24px auto 0;width:76px}.ct-video-view.mobile{border:1px solid #ddd;max-width:100%;min-width:0}.ct-video-view.mobile video{margin:0}';
styleInject(css_248z$1);

function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var videoRender = function videoRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$2(this, videoRender);
    this.fragmentRender = function(node) {
        var url = node.getAttribute("data-url");
        var name = node.getAttribute("data-name");
        var size = node.getAttribute("data-size");
        var width = parseInt(node.getAttribute("data-width"), 10) || 0;
        var height = parseInt(node.getAttribute("data-height"), 10) || 0;
        var provider = new AudioProvider();
        ReactDOM.render(/*#__PURE__*/ React.createElement(Video, {
            url: url,
            name: name,
            size: size,
            width: width,
            height: height,
            provider: provider,
            resizer: false
        }), node);
    };
    this.fragmentCls = ".".concat(classNamePrefix("video"));
    this.config = config;
};

export default videoRender;
//# sourceMappingURL=render.js.map
